/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：394
 */

"use strict"

export { i as a }
import * as /* [auto-meaningful-name] */Module_292 from /* 292 */"../217/292"
function i(e) {
  return function t(n) {
    return 0 === arguments.length || Module_292.a(n) ? t : e.apply(this, arguments)
  }
}
export default i
